import styled from '@emotion/styled'
import { css } from '@emotion/react'

const wrapperStyles = ({ theme }) => css`
  label: wrapper;

  margin-bottom: ${theme.spacings.byte};
`

export const Wrapper = styled('div')(wrapperStyles)
